import i18next from 'i18next';

i18next.addResources('es', 'CaseCreation', {
  answerRequired: 'Requerido',
  numberAnswerRequired: 'Requerido. Debe ser un número.',
  updateSuccess: 'Se guardó el caso correctamente.',
  updateError: 'Hubo un error al guardar el caso.'
});
